import type { ServiceStoreConfig } from "../types/ServiceStoreTypes";
import { reportsServiceStores } from "@intrasync/reports";

/**
 * Reports tool ServiceStores — the eight @intrasync/reports needs for its
 * default (`reports`) mount: `reports-catalog`, `reports-enablement`,
 * `reports-runs`, `reports-views`, `reports-view-shares`, `reports-schedules`,
 * `reports-letterheads`, `reports-settings`.
 *
 * NAMED `reportsToolStores`, NOT `reportsStores`: that export already exists in
 * `reports.stores.ts` and carries the Developer Metrics stores. The two live
 * side by side in the "Reports" area and must not be confused or collide.
 *
 * The configs come FROM THE LIBRARY, exactly as `dashboard.stores.ts` takes the
 * dashboard's: the store `name` IS the Feathers path the host-mounted
 * @intrasync/reports-api registers, and the library's `hostBinding` looks the
 * stores up on the rootStore by the derived keys (`reportsCatalogStore`, …).
 * A hand copy would be a second place for the paths to drift.
 *
 * The options are the library's doctrine and are pinned by
 * reportsTool.stores.test.ts: `enableStorage: false` (a private view must never
 * sit in another person's browser cache), `enableOffline: false` (a write that
 * cannot reach the server fails visibly) and `disableInitialFind` on every
 * store (each hub tab loads on first use, so nothing is fetched at boot).
 *
 * THE CAST: the same one boundary cast as `dashboard.stores.ts` — HQ's
 * `ServiceStoreOptions` does not declare `exhaustivePagination`, so the
 * library's `ServiceStoreConfig[]` is not assignable to HQ's without it.
 */
export const reportsToolStores: ServiceStoreConfig[] =
  reportsServiceStores as unknown as ServiceStoreConfig[];
